import {
  Component,
  OnInit,
  ViewChild
} from '@angular/core';
import { ActivityView } from '../../../../../views/master-views/app.view/app.view.component';
import {
  AgendaItemActivity,
  AgendaItemActivityModel
} from 'src/app/models/activities';
import { ToastrService } from 'ngx-toastr';
import { FormActivityInputViewComponent } from '../../form-activity-editor/form-activity-input/form-activity-input-view/form-activity-input-view.component';

@Component({
    selector: 'wm-agenda-item-activity-input',
    templateUrl: './agenda-item-activity-input.component.html',
    styleUrls: ['./agenda-item-activity-input.component.css'],
    standalone: false
})
export class AgendaItemActivityInputComponent extends ActivityView
  implements OnInit {
  @ViewChild('formActivityInputView', { static: false }) formActivityInputViewCtl: FormActivityInputViewComponent;

  evaluatedAgendaItem: string;

  constructor(private _toastr: ToastrService) {
    super();
  }

  ngOnInit() {
    if (this.activity.feedbackMessage && this.activity.feedbackMessage !== '') {
      this._toastr.success(this.activity.feedbackMessage);
    }
    
    const activity = this.activity as AgendaItemActivity;
    this.evaluatedAgendaItem = (activity.model as AgendaItemActivityModel).queueItem.evaluatedAgendaItem;
  }

  async persistChildComponent?() {
    return this.formActivityInputViewCtl.persistChildComponent();
  }
}
